import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { logRavenException } from '../../../utils/ravenWrapperUtil';
const BASE_URL = `properties/v4`;
const DEAL_OBJECT_ID = '0-3';
export const fetchPropertyGroups = () => http.get(`${BASE_URL}/groups/${DEAL_OBJECT_ID}`, {
  query: {
    includeFieldLevelPermission: true,
    includeProperties: true
  }
}).catch(error => {
  logRavenException(error, 'Fetch property groups');
  return null;
});
export const GET_PROPERTY_GROUPS = registerQuery({
  fieldName: 'propertyGroups',
  async fetcher() {
    return await fetchPropertyGroups();
  }
});